import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "default-form" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = { class: "input dropdown-input" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "input-row first-row" }
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_9 = { class: "input-wr" }
const _hoisted_10 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_11 = { class: "input-row" }
const _hoisted_12 = { class: "input-wr" }
const _hoisted_13 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_14 = { class: "input-wr state" }
const _hoisted_15 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_16 = { class: "input-wr postcode" }
const _hoisted_17 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_18 = { class: "input-row large" }
const _hoisted_19 = { class: "input-wr" }
const _hoisted_20 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_21 = { class: "input-row total-deposit-row" }
const _hoisted_22 = { class: "input-wr" }
const _hoisted_23 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_24 = { class: "input-row" }
const _hoisted_25 = { class: "input-wr" }
const _hoisted_26 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_27 = { class: "input-wr" }
const _hoisted_28 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_29 = { class: "input-row gst-row" }
const _hoisted_30 = { class: "gst-options-wr" }
const _hoisted_31 = { class: "gst-options" }
const _hoisted_32 = {
  key: 0,
  class: "input-wr short"
}
const _hoisted_33 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_34 = { class: "input-row first-row" }
const _hoisted_35 = { class: "input-wr short" }
const _hoisted_36 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_37 = { class: "input-row large first-row" }
const _hoisted_38 = { class: "input-wr" }
const _hoisted_39 = { class: "additional-terms-wr" }
const _hoisted_40 = { class: "checkbox" }
const _hoisted_41 = {
  key: 0,
  class: "input-row settlement-discount-row"
}
const _hoisted_42 = { class: "input-wr short" }
const _hoisted_43 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_44 = {
  key: 1,
  class: "input-row subject-to-finance-row"
}
const _hoisted_45 = { class: "input-wr" }
const _hoisted_46 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_47 = { class: "input-wr" }
const _hoisted_48 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_49 = { class: "controls" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 0,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: "without-padding"
  }, {
    content: _withCtx(() => [
      _cache[49] || (_cache[49] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("h1", { class: "header--title" }, "Contract Particulars")
      ], -1)),
      _createElementVNode("div", {
        class: "body scroll-wrapper",
        onSubmit: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "info-block" }, [
          _createElementVNode("div", { class: "info-block--text" }, "Complete & review required information below.")
        ], -1)),
        _createElementVNode("form", _hoisted_1, [
          _cache[42] || (_cache[42] = _createElementVNode("p", { class: "section-title" }, "Docusign Details", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label" }, "Select Template", -1)),
              _createVNode($setup["DropDown"], null, {
                control: _withCtx(() => [
                  _createElementVNode("label", _hoisted_4, _toDisplayString($setup.template?.name || "Select Template"), 1)
                ]),
                dropdown: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.templatesList, (templateItem) => {
                    return (_openBlock(), _createElementBlock("ul", null, [
                      _createElementVNode("li", {
                        onClick: ($event: any) => ($setup.template = templateItem)
                      }, _toDisplayString(templateItem?.name), 9, _hoisted_5)
                    ]))
                  }), 256))
                ]),
                _: 1
              })
            ])
          ]),
          _cache[43] || (_cache[43] = _createElementVNode("p", { class: "section-title" }, "Property Details", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label" }, "Lot Number", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "123",
                onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.v$.lotNumber.$touch && $setup.v$.lotNumber.$touch(...args))),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lotNumber) = $event))
              }, null, 544), [
                [_vModelText, $setup.form.lotNumber]
              ]),
              ($setup.v$.lotNumber.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.v$.lotNumber.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "label" }, "Size", -1)),
              _createVNode($setup["Cleave"], {
                class: "input",
                placeholder: "100",
                options: $setup.cleaveInputOptions,
                onBlur: $setup.v$.size.$touch,
                modelValue: $setup.form.size,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.size) = $event))
              }, null, 8, ["options", "onBlur", "modelValue"]),
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "sqm" }, "sqm", -1)),
              ($setup.v$.size.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.size.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "label" }, "Suburb", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Collingwood Park",
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.v$.suburb.$touch && $setup.v$.suburb.$touch(...args))),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.suburb) = $event))
              }, null, 544), [
                [_vModelText, $setup.form.suburb]
              ]),
              ($setup.v$.suburb.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.v$.suburb.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "label" }, "State", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "QLD",
                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.v$.state.$touch && $setup.v$.state.$touch(...args))),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.state) = $event)),
                maxlength: "3"
              }, null, 544), [
                [_vModelText, $setup.form.state]
              ]),
              ($setup.v$.state.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.v$.state.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "4301",
                maxlength: "4",
                onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.v$.postcode.$touch && $setup.v$.postcode.$touch(...args))),
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.postcode) = $event))
              }, null, 544), [
                [_vModelText, $setup.form.postcode]
              ]),
              ($setup.v$.postcode.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.v$.postcode.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "label" }, "Street address", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "123 Smith Street",
                onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.v$.streetAddress.$touch && $setup.v$.streetAddress.$touch(...args))),
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.streetAddress) = $event))
              }, null, 544), [
                [_vModelText, $setup.form.streetAddress]
              ]),
              ($setup.v$.streetAddress.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.v$.streetAddress.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[44] || (_cache[44] = _createElementVNode("p", { class: "section-title" }, "Deposit Details", -1)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "label" }, "Total deposit", -1)),
              _createVNode($setup["Cleave"], {
                class: "input",
                placeholder: "$15,000",
                options: $setup.cleaveInputOptions,
                onInput: $setup.onChangeTotalDepositChange,
                modelValue: $setup.form.depositDetails.totalDeposit,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.form.depositDetails.totalDeposit) = $event)),
                onBlur: $setup.v$.depositDetails.totalDeposit.$touch
              }, null, 8, ["options", "onInput", "modelValue", "onBlur"]),
              ($setup.v$.depositDetails.totalDeposit.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.v$.depositDetails.totalDeposit.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["button deposit-button", { active: $setup.depositPercentage === 5 }]),
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.onSelectdepositPercentage(($setup.depositPercentage = 5)))),
              type: "button"
            }, "5%", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["button deposit-button", { active: $setup.depositPercentage === 10 }]),
              type: "button",
              onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.onSelectdepositPercentage(($setup.depositPercentage = 10))))
            }, "10%", 2)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "label" }, "Paid:", -1)),
              _createVNode($setup["Cleave"], {
                class: "input",
                placeholder: "$0.00",
                onInput: _cache[14] || (_cache[14] = ($event: any) => ($setup.onChangeBalance($event))),
                options: $setup.cleaveInputOptions,
                modelValue: $setup.form.depositDetails.paid,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.form.depositDetails.paid) = $event)),
                onBlur: $setup.v$.depositDetails.paid.$touch
              }, null, 8, ["options", "modelValue", "onBlur"]),
              ($setup.v$.depositDetails.paid.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString($setup.v$.depositDetails.paid.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "label" }, "Balance:", -1)),
              _createVNode($setup["Cleave"], {
                class: "input",
                placeholder: "$15,000",
                options: $setup.cleaveInputOptions,
                modelValue: $setup.form.depositDetails.balance,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.form.depositDetails.balance) = $event)),
                onBlur: $setup.v$.depositDetails.balance.$touch
              }, null, 8, ["options", "modelValue", "onBlur"]),
              ($setup.v$.depositDetails.balance.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString($setup.v$.depositDetails.balance.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "input-wr" }, [
                _createElementVNode("label", { class: "label" }, "GST?")
              ], -1)),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: _normalizeClass(["button deposit-button", { active: $setup.form.depositDetails.gst }]),
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.form.depositDetails.gst = true))
                }, "Yes", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["button deposit-button", { active: !$setup.form.depositDetails.gst }]),
                  onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.form.depositDetails.gst = false))
                }, "No", 2)
              ])
            ]),
            ($setup.form.depositDetails.gst)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "label" }, "GTS amount:", -1)),
                  _createVNode($setup["Cleave"], {
                    class: "input",
                    placeholder: "$15,000",
                    options: $setup.cleaveInputOptions,
                    modelValue: $setup.form.depositDetails.gstAmount,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.form.depositDetails.gstAmount) = $event)),
                    onBlur: $setup.v$.depositDetails.gstAmount.$touch
                  }, null, 8, ["options", "modelValue", "onBlur"]),
                  ($setup.v$.depositDetails.gstAmount.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString($setup.v$.depositDetails.gstAmount.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[45] || (_cache[45] = _createElementVNode("p", { class: "section-title" }, "Settlement date:", -1)),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode($setup["DatePicker"], {
                position: "top right",
                showPlaceholder: "",
                customPlaceholder: $setup.datePickerPlaceholder,
                modelValue: $setup.form.settlementDate,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.form.settlementDate) = $event))
              }, null, 8, ["customPlaceholder", "modelValue"]),
              ($setup.v$.settlementDate.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString($setup.v$.settlementDate.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[46] || (_cache[46] = _createElementVNode("p", { class: "section-title" }, "Additional terms:", -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "label" }, "Select all that apply:", -1)),
              _createElementVNode("div", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.additionalTerms, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createVNode($setup["CheckboxInput"], {
                      label: item.label,
                      selected: item.isSelected,
                      modelValue: item.isSelected,
                      "onUpdate:modelValue": ($event: any) => (item.isSelected = !item.isSelected)
                    }, null, 8, ["label", "selected", "modelValue", "onUpdate:modelValue"]),
                    (item.isSelected && item.label === $setup.EARLY_SETTLEMENT_DISCOUNT)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _cache[38] || (_cache[38] = _createElementVNode("label", { class: "label" }, "Amount:", -1)),
                            _createVNode($setup["Cleave"], {
                              class: "input",
                              placeholder: "$2,500",
                              modelValue: $setup.form.earlySettlementDiscount.amount,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.form.earlySettlementDiscount.amount) = $event)),
                              options: $setup.cleaveInputOptions
                            }, null, 8, ["modelValue", "options"]),
                            ($setup.v$.earlySettlementDiscount.amount.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString($setup.v$.earlySettlementDiscount.amount.$errors[0].$message), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (item.isSelected && item.label === $setup.SUBJECT_TO_FINANCE)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "label" }, "Loan amount:", -1)),
                            _createVNode($setup["Cleave"], {
                              class: "input",
                              placeholder: "$15,000",
                              modelValue: $setup.form.subjectToFinance.loanAmount,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.form.subjectToFinance.loanAmount) = $event)),
                              options: $setup.cleaveInputOptions
                            }, null, 8, ["modelValue", "options"]),
                            ($setup.v$.subjectToFinance.loanAmount.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString($setup.v$.subjectToFinance.loanAmount.$errors[0].$message), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "label" }, "Finance due date:", -1)),
                            _createVNode($setup["DatePicker"], {
                              position: "top right",
                              showPlaceholder: "",
                              modelValue: $setup.form.subjectToFinance.financeDueDate,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.form.subjectToFinance.financeDueDate) = $event)),
                              customPlaceholder: $setup.datePickerPlaceholder
                            }, null, 8, ["modelValue", "customPlaceholder"]),
                            ($setup.v$.subjectToFinance.financeDueDate.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString($setup.v$.subjectToFinance.financeDueDate.$errors[0].$message), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("button", {
            class: "button outlined",
            onClick: $setup.onClose
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary submit",
            onClick: $setup.submit,
            disabled: $setup.loading
          }, [
            _cache[47] || (_cache[47] = _createTextVNode("Generate & Review", -1)),
            ($setup.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51))
              : _createCommentVNode("", true)
          ], 8, _hoisted_50)
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["isOpen"]))
}